import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import Confetti from "react-confetti";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const ThankYouPage = () => {
  const location = useLocation();

  // ✅ Read from React Router state OR fallback to URL query params
  const searchParams = new URLSearchParams(location.search);
  const queryOrderId = searchParams.get("orderid") || searchParams.get("orderId");
  const queryOrderNo = searchParams.get("orderno") || searchParams.get("orderNo");

  const { orderId: stateOrderId, orderNo: stateOrderNo } = location.state || {};

  const orderId = stateOrderId || queryOrderId;
  const orderNo = stateOrderNo || queryOrderNo || queryOrderId;

  const [orderDetails, setOrderDetails] = useState(null);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // ✅ Fetch order details from backend when orderId is available
  useEffect(() => {

    
    if (orderId) {

         [
        "cart",
        "orderType",
        "orderTiming",
        "scheduleDate",
        "scheduleTime",
        "addresses",
        "selectedAddressId",
        "specialInstruction",
        "couponCode",
        "appliedVouchers",
        "deviceId",
        "editComboItem",
        "dinein",
        "orderService",
        "serviceSelection",
      ].forEach((key) => localStorage.removeItem(key));
      
      axios
        .get(`${window.BASE_API_URL}sent-notification/${orderId}`)
        .then((res) => {
          console.log("✅ API response:", res.data);
          setOrderDetails(res.data.data);
        })
        .catch((err) => {
          console.error("❌ Error fetching order details:", err);
        });
    }
  }, [orderId]);

  // ✅ Dynamically update Confetti size
  useEffect(() => {
    const handleResize = () =>
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-start bg-gradient-to-b from-amber-50 to-white px-4 pt-20 relative overflow-hidden">
      {/* 🎉 Confetti */}
      <Confetti width={windowSize.width} height={windowSize.height} numberOfPieces={250} />

      {/* ✅ Thank You Box */}
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="bg-white shadow-2xl rounded-2xl p-10 max-w-md w-full text-center border border-amber-100"
      >
        {/* ✅ Animated Check */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1.1 }}
          transition={{ duration: 0.6, type: "spring" }}
          className="flex justify-center mb-6"
        >
          <CheckCircle className="w-16 h-16 text-green-500 drop-shadow-lg" />
        </motion.div>

        <h1 className="text-4xl font-extrabold text-amber-700 mb-3">🎉 Thank You!</h1>
        <p className="text-gray-700 text-lg mb-6">
          Your order has been placed successfully.
        </p>

  {orderDetails && orderDetails?.delivery_type == 'P' && orderDetails?.payment_method == 'cash' && (
         <p className="text-gray-700 text-lg mb-6">
          You have selected Pickup. Payment can be made by cash or card when you collect your order.
        </p>

  )}

        {/* ✅ Order Info */}
        {orderId ? (
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-left">
            <p className="text-gray-800 font-semibold">
              Order No: <span className="text-amber-700">{orderDetails?.order_no}</span>
            </p>

            {orderDetails ? (
              <>
                <p className="text-gray-700 mt-1">
                  <span className="font-medium">Date:</span>{" "}
                  {orderDetails.order_date || "N/A"}
                </p>
                <p className="text-gray-700">
                  <span className="font-medium">Time:</span>{" "}
                  {orderDetails.order_time || "N/A"}
                </p>

                {orderDetails?.is_accept == 1 &&<p className="text-red-900">
                  <br/>
                  <span className="font-medium">
                    Restaurant will soon confirm if they accept or reject your order. </span>
                </p>
              }
              </>
            ) : (
              <p className="text-sm text-gray-500 mt-2 italic">
                Fetching order details...
              </p>
            )}
          </div>
        ) : (
          <p className="text-gray-500 italic mb-6">
            No order information found in URL.
          </p>
        )}



        {/* ✅ Download Receipt */}
        {orderId && orderDetails?.is_accept != 1 && (
          <a
            href={`${window.BASE_URL}/download-reciept/${orderId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mb-4 px-6 py-2 rounded-full bg-green-600 text-white font-semibold hover:bg-green-700 transition"
          >
            Download Receipt
          </a>
        )}
        <br />


 {orderDetails && orderDetails?.delivery_type != 'DI' && 
  
        <Link
          to="/"
          className="inline-block px-6 py-2 rounded-full bg-amber-600 text-white font-semibold hover:bg-amber-700 transition"
        >
          Go to Home
        </Link> }

        <br/>

         {orderDetails && orderDetails?.delivery_type == 'DI' &&
         <p className="text-sm text-gray-500 mt-2 italic">
           Scan again to place order
              </p> }
      </motion.div>
    </div>
  );
};

export default ThankYouPage;
